module.exports = __webpack_public_path__ + "img/bg_404.15b1f178.svg";